var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.575 15.6726L2.94 0.460646C2.95712 0.347884 3.00937 0.243396 3.08933 0.162058C3.16928 0.0807187 3.27285 0.0266746 3.3853 0.00761889C3.49776 -0.0114368 3.61335 0.00546702 3.71564 0.0559241C3.81792 0.106381 3.90169 0.18782 3.955 0.288646L6.498 5.05965L0.575 15.6726ZM17.37 19.3636L15.118 5.36465C15.1014 5.26652 15.0582 5.17484 14.9931 5.0996C14.928 5.02436 14.8434 4.96847 14.7487 4.93803C14.654 4.90758 14.5527 4.90376 14.4559 4.92697C14.3591 4.95018 14.2706 4.99954 14.2 5.06965L0 19.3636L7.857 23.7916C8.09931 23.9278 8.37257 23.9993 8.6505 23.9993C8.92843 23.9993 9.20169 23.9278 9.444 23.7916L17.37 19.3636ZM10.985 7.14765L9.165 3.66565C9.11908 3.57808 9.05008 3.50475 8.96547 3.45358C8.88087 3.40242 8.78387 3.37537 8.685 3.37537C8.58612 3.37537 8.48913 3.40242 8.40453 3.45358C8.31992 3.50475 8.25092 3.57808 8.205 3.66565L0.215 17.9836L10.985 7.14765Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.6c1e54add7eefb20c6e77a1fb7acdee5.svg";
export { ForwardRef as ReactComponent };